export default "__VITE_ASSET__BRZzpyMS__"